import {
    userVoiceSearchSuggestionNoResults,
    userVoiceSearchSuggestionSlowResults,
    userVoiceSearchSuggestionResultsNotRelevant,
    userVoiceSearchSuggestionItemNotFound,
    userVoiceSearchSuggestionSuggestionsNotUseful,
    userVoiceSearchSuggestionClientUXHardToUse,
    userVoiceSearchSuggestionOther,
} from './UserVoiceConstants.locstring.json';
import loc from 'owa-localize';
import { SearchSuggestionOptionState } from '../store/schema/SearchSuggestionOptionState';

import getOwaNonBootUserConfigurationOperation from 'owa-service/lib/operation/getOwaNonBootUserConfigurationOperation';
import OwaNonBootUserConfiguration from 'owa-service/lib/contract/OwaNonBootUserConfiguration';

export const NotApplicable = 'N/A';
export const Empty = '';
export const CheckError = 'CheckErrorDetails';
export const ReactNpsClientName = 'React/Nps';
export const NpsLogDatapointId = 'UVNpsRating';
export const FeedbackTitle = '';
export const FeedbackLogDatapointId = 'UVFeedback';
export const ReactFeedbackClientName = 'React/Feedback';
export const SearchCustomFieldNameFormat = 'Search_{0}';
export const NoUserMessageLiteral = 'NoUserMessage';
export const UserVoiceForumUrlFormat = 'https://outlook.uservoice.com/forums/{0}';
export const consumerForumId: number = 601444;
export const enterpriseForumId: number = 907141;
export const ideasPageSize: number = 4;
export const moreIdeasPageSize: number = 15;

export function SearchSuggestionOptions(): SearchSuggestionOptionState[] {
    return [
        { name: 'NoResults', label: loc(userVoiceSearchSuggestionNoResults) },
        { name: 'SlowResults', label: loc(userVoiceSearchSuggestionSlowResults) },
        { name: 'ResultsNotRelevant', label: loc(userVoiceSearchSuggestionResultsNotRelevant) },
        { name: 'ItemNotFound', label: loc(userVoiceSearchSuggestionItemNotFound) },
        {
            name: 'SuggestionsNotUseful',
            label: loc(userVoiceSearchSuggestionSuggestionsNotUseful),
        },
        { name: 'ClientUXHardToUse', label: loc(userVoiceSearchSuggestionClientUXHardToUse) },
        { name: 'Other', label: loc(userVoiceSearchSuggestionOther) },
    ];
}

export function GetSurveyNumber(isFirstSurvey: boolean) {
    return isFirstSurvey ? '1' : '2';
}

export async function GetLicenseInfo(): Promise<string> {
    let owaUserConfig: OwaNonBootUserConfiguration = await getOwaNonBootUserConfigurationOperation();
    return owaUserConfig.ConsumerSubscriptions
        ? owaUserConfig.ConsumerSubscriptions.join(',')
        : Empty;
}
